import React from 'react';
import { logEvent } from 'firebase/analytics';
import posthog from 'posthog-js';
import { Footer } from '../../commons';
import { Welcome, Application, Closing, Categories } from '../../home';
import { loadAnalytics } from '../../../lib';

export default function HomePage() {
  React.useEffect(() => {
    logEvent(loadAnalytics(), 'page_view', {
      page_title: 'Home',
    });
  }, []);

  return (
    <div className="relative bg-transparent z-10 overflow-x-hidden">
      <Welcome />
      <Categories />
      <div
        className="absolute w-[464.29px] h-[500px] left-[-190px] bg-cyan -rotate-45 rounded-2xl z-[-1]"
        style={{
          top: `${801 + 751.11}px`,
        }}
      />
      <div
        className="absolute w-[464.29px] h-[500px] right-[-190px] bg-green rounded-full z-[-1]"
        style={{
          top: `${801 + 751.11 + 350}px`,
        }}
      />
      <Application />
      <Closing />
      <Footer />
    </div>
  );
}
